<template>
  <div :class="pitchtype.leadPrice ? '' : 'pt-status-msg ct-status-msg'">
    <pricing-period-non-dated
      v-if="pitchtype.leadPrice"
      :lead-price="pitchtype.leadPrice"
      :lead-price-with-excluded="pitchtype.leadPriceWithExcluded"
      :lead-price-nights="pitchtype.leadPriceNights"
      :lead-price-persons="Math.min(pitchtype.capacity, 2)"
    />
    <span v-else>
      <img src="@/assets/images/warning.svg" width="32" height="32" alt="" />
      <translate data-test="no-availability-on-our-site-3"
        >No availability on our site</translate
      >
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { PitchType } from '../../../../campsite-details/types'

@Component
class PitchTypeState extends Vue {
  @Prop()
  pitchtype: PitchType
}

export default toNative(PitchTypeState)
</script>
